var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.57,24H8.43a2.93,2.93,0,0,1-2.92-2.92V2.92A2.93,2.93,0,0,1,8.43,0h7.14a2.93,2.93,0,0,1,2.92,2.92V21.08A2.93,2.93,0,0,1,15.57,24ZM8.43,1.39A1.53,1.53,0,0,0,6.9,2.92V21.08a1.53,1.53,0,0,0,1.53,1.53h7.14a1.53,1.53,0,0,0,1.53-1.53V2.92a1.53,1.53,0,0,0-1.53-1.53Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,22a.64.64,0,0,1-.27-.05.54.54,0,0,1-.22-.15.52.52,0,0,1-.15-.23.58.58,0,0,1-.06-.26.67.67,0,0,1,.21-.49.54.54,0,0,1,.22-.15.69.69,0,0,1,.76.15.67.67,0,0,1,.21.49.71.71,0,0,1-.21.49A.68.68,0,0,1,12,22Z",
    fill: "#e30613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.19,20H8.8a.7.7,0,1,1,0-1.39h6.4a.7.7,0,0,1,0,1.39Z",
    fill: "#e30613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.86,4.1H10.14a.7.7,0,1,1,0-1.39h3.73a.7.7,0,1,1,0,1.39Z",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokMobile);
export default __webpack_public_path__ + "static/media/hok-mobile.0a3ade7b00c5be81e8a5949e46cc63bd.svg";
export { ForwardRef as ReactComponent };